// extracted by mini-css-extract-plugin
export default {"dropdown":"style_dropdown__2VG2O","dropdown__item":"style_dropdown__item__06a54"};